import { Component, OnInit, Input } from '@angular/core';
import { RopeShovelService } from '../../rope-shovel.service';
import { EquipmentPhotoModel } from '../../models/rope-shovel.model';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'mandatory-component-photos',
  templateUrl: './mandatory-component-photos.component.html',
  styleUrls: ['./mandatory-component-photos.component.scss'],
  animations: [
    trigger(
      'fadeIn', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms', style({ opacity: 1 }))
        ]),
        transition(':leave', [
          style({ opacity: 1 }),
          animate('500ms', style({ opacity: 0 }))
        ])
      ]
    )]
})
export class MandatoryComponentPhotosComponent implements OnInit {
  @Input() inspectionId: number = 0;
  @Input() compartTypeId: number = 0;
  @Input() side: string = "Left";
  photos: EquipmentPhotoModel[] = [];

  constructor(private _service: RopeShovelService) { }

  ngOnInit() {
    this._service.getMandatoryPhotosForInspectionCompartType(this.inspectionId, this.compartTypeId, this.side).subscribe(r => {
      this.photos = r;
    });
  }

}
